<h3 *ngIf="!isFirstLogin">Change Password</h3>
<form novalidate [formGroup]="profileForm">
  <app-input-field label="Current Password" *ngIf="!isFirstLogin" [control]="currentPassword" type="password"
    name="oldPassword">
  </app-input-field>
  <app-input-field class="mb-4" label="New Password" [control]="password" type="password" name="newPassword" [patternMsg]="!profileForm.get('password').value? 'Please enter password':'No space, atleast one capital letter, atleast one small letter, atleast one number and atleast one special character. Eg. St2022#Sbm'"></app-input-field>
  <app-input-field label="Confirm Password" [control]="confirmPassword" type="password" name="confirm password">
  </app-input-field>
  <button class="btn btn-primary upbtn  btn-block" type="submit" *ngIf="isFirstLogin" (click)="onSubmit()"> Submit </button>
  <div class="mb-1 mt-1" *ngIf="!isFirstLogin">
    <button mat-raised-button class="adc" type="submit" color="primary" (click)="onSubmit()">Submit</button>
    <button mat-button (click)="onNoClick()" color="primary" cdkFocusInitial class="ml-2">Cancel</button>
  </div>
</form>
